import { atom } from 'jotai';

export const showFacetsAsideAtom = atom(null);
showFacetsAsideAtom.debugLabel = 'showFacetsAsideAtom';
export const bodyContentRefAtom = atom(null);
